/**
 * Uzysk PV w Polsce — kWh z 1 kWp w każdym miesiącu, wg województwa i ustawienia dachu.
 *
 * PLIK JEST GENEROWANY przez tools/pobierz_pvgis.py. Nie edytuj ręcznie.
 *
 * ŹRÓDŁO: PVGIS 5.2 (Komisja Europejska, JRC), baza PVGIS-SARAH2, meteo ERA5,
 * średnia z lat 2005–2020, technologia c-Si, straty systemowe 14%.
 * Punkt pomiarowy: środek geograficzny województwa.
 *
 * DOKŁADNOŚĆ: to średnia wieloletnia dla środka województwa, a nie prognoza dla
 * konkretnego dachu. Rok od roku produkcja waha się o ±10%, a zacienienie
 * i odchylenie od zakładanego kąta potrafią zabrać więcej.
 */

export const STRATY_SYSTEMOWE_PROC = 14

export const MIESIACE = [
  'Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru',
]

export const UZYSK_MIESIECZNY = {
  "dolnoslaskie": {
    "poludnie": [
      36.5,
      52.7,
      90.4,
      126.0,
      130.7,
      129.4,
      130.8,
      124.5,
      104.7,
      78.5,
      48.6,
      38.8
    ],
    "poludnie_bok": [
      30.6,
      45.5,
      82.8,
      120.3,
      127.2,
      127.9,
      127.8,
      119.2,
      95.6,
      69.3,
      40.8,
      31.9
    ],
    "plaski": [
      25.6,
      41.1,
      78.3,
      118.2,
      131.9,
      134.5,
      134.4,
      120.7,
      92.6,
      62.1,
      34.1,
      24.8
    ],
    "wschod_zachod": [
      18.7,
      32.5,
      65.8,
      103.2,
      119.3,
      123.5,
      123.0,
      107.2,
      78.5,
      49.1,
      24.5,
      16.5
    ],
    "jedna_polac": [
      18.8,
      33.0,
      65.7,
      102.3,
      119.9,
      123.5,
      124.4,
      108.3,
      79.9,
      48.9,
      24.3,
      16.3
    ],
    "polnoc": [
      10.2,
      16.2,
      30.1,
      58.9,
      90.3,
      102.2,
      98.9,
      70.6,
      34.4,
      20.6,
      11.4,
      7.9
    ]
  },
  "kujawsko-pomorskie": {
    "poludnie": [
      30.4,
      49.8,
      88.0,
      125.2,
      131.1,
      130.3,
      128.5,
      122.5,
      100.2,
      68.9,
      30.8,
      25.4
    ],
    "poludnie_bok": [
      24.9,
      43.0,
      79.8,
      118.1,
      125.7,
      127.7,
      126.4,
      117.7,
      91.3,
      60.4,
      26.2,
      20.1
    ],
    "plaski": [
      20.5,
      37.7,
      75.2,
      116.5,
      131.5,
      134.9,
      131.3,
      117.9,
      87.9,
      54.2,
      22.1,
      16.2
    ],
    "wschod_zachod": [
      14.6,
      29.2,
      63.1,
      101.5,
      119.3,
      123.9,
      120.2,
      105.0,
      74.6,
      43.1,
      16.6,
      10.8
    ],
    "jedna_polac": [
      14.9,
      29.2,
      63.7,
      102.1,
      122.5,
      125.8,
      120.2,
      105.4,
      76.1,
      43.5,
      16.5,
      11.2
    ],
    "polnoc": [
      7.9,
      14.2,
      27.9,
      55.7,
      88.8,
      101.8,
      95.3,
      67.3,
      32.4,
      19.2,
      9.2,
      5.9
    ]
  },
  "lubelskie": {
    "poludnie": [
      32.5,
      48.0,
      83.5,
      122.7,
      129.8,
      136.1,
      134.8,
      130.9,
      106.6,
      79.0,
      39.8,
      28.2
    ],
    "poludnie_bok": [
      27.1,
      42.3,
      77.3,
      115.7,
      126.3,
      134.0,
      131.9,
      124.2,
      98.3,
      69.3,
      33.9,
      22.9
    ],
    "plaski": [
      23.1,
      38.2,
      73.4,
      115.3,
      130.8,
      141.0,
      138.0,
      126.2,
      94.0,
      62.4,
      28.6,
      18.9
    ],
    "wschod_zachod": [
      17.4,
      30.7,
      62.4,
      100.4,
      117.9,
      128.6,
      125.5,
      111.5,
      79.2,
      49.4,
      21.3,
      13.3
    ],
    "jedna_polac": [
      17.7,
      30.8,
      62.2,
      101.1,
      118.5,
      129.1,
      126.4,
      112.7,
      79.1,
      49.7,
      21.2,
      13.5
    ],
    "polnoc": [
      10.0,
      16.5,
      30.4,
      57.7,
      89.3,
      105.2,
      99.9,
      71.8,
      33.7,
      20.4,
      10.8,
      7.4
    ]
  },
  "lubuskie": {
    "poludnie": [
      33.1,
      52.9,
      85.5,
      123.9,
      125.6,
      125.9,
      128.4,
      121.5,
      101.3,
      69.6,
      36.4,
      28.7
    ],
    "poludnie_bok": [
      27.0,
      45.5,
      77.5,
      117.3,
      121.3,
      124.0,
      126.4,
      116.4,
      92.9,
      61.0,
      30.5,
      23.7
    ],
    "plaski": [
      22.6,
      40.2,
      73.5,
      116.2,
      126.9,
      130.9,
      131.5,
      117.7,
      89.5,
      55.2,
      25.9,
      18.5
    ],
    "wschod_zachod": [
      16.1,
      31.4,
      61.8,
      101.8,
      115.8,
      121.0,
      120.7,
      104.9,
      76.4,
      44.1,
      19.2,
      12.6
    ],
    "jedna_polac": [
      16.6,
      31.8,
      62.4,
      102.6,
      118.2,
      122.3,
      121.0,
      106.0,
      77.7,
      44.6,
      19.4,
      12.4
    ],
    "polnoc": [
      8.4,
      14.7,
      27.4,
      57.6,
      88.5,
      100.7,
      96.4,
      68.9,
      34.0,
      20.0,
      10.0,
      6.6
    ]
  },
  "lodzkie": {
    "poludnie": [
      34.9,
      49.9,
      87.7,
      121.6,
      129.3,
      130.5,
      129.4,
      126.1,
      103.9,
      73.7,
      37.3,
      28.6
    ],
    "poludnie_bok": [
      29.1,
      43.5,
      80.2,
      114.6,
      124.3,
      127.2,
      126.5,
      120.2,
      95.3,
      65.2,
      31.8,
      23.5
    ],
    "plaski": [
      24.1,
      39.0,
      75.9,
      114.2,
      130.2,
      135.7,
      132.8,
      121.9,
      91.6,
      58.4,
      26.9,
      18.8
    ],
    "wschod_zachod": [
      17.5,
      30.9,
      64.2,
      99.9,
      117.9,
      124.5,
      121.4,
      108.5,
      77.5,
      46.2,
      19.9,
      12.8
    ],
    "jedna_polac": [
      17.7,
      30.9,
      64.4,
      100.9,
      120.6,
      127.3,
      122.6,
      109.8,
      78.5,
      46.1,
      19.7,
      12.7
    ],
    "polnoc": [
      9.4,
      15.8,
      29.5,
      57.6,
      89.2,
      103.4,
      97.5,
      70.7,
      33.7,
      20.0,
      10.4,
      6.8
    ]
  },
  "malopolskie": {
    "poludnie": [
      39.8,
      50.8,
      86.6,
      113.4,
      114.1,
      116.6,
      125.6,
      120.6,
      99.5,
      78.1,
      48.3,
      34.4
    ],
    "poludnie_bok": [
      33.5,
      45.0,
      79.4,
      107.5,
      110.9,
      114.2,
      122.7,
      114.2,
      92.3,
      69.2,
      41.1,
      28.9
    ],
    "plaski": [
      28.8,
      40.9,
      76.2,
      108.0,
      116.1,
      121.8,
      129.4,
      117.6,
      89.1,
      62.5,
      35.2,
      23.7
    ],
    "wschod_zachod": [
      20.5,
      32.7,
      64.7,
      95.1,
      105.9,
      112.0,
      118.1,
      104.6,
      75.9,
      49.5,
      25.1,
      16.1
    ],
    "jedna_polac": [
      20.6,
      32.6,
      65.2,
      95.8,
      107.4,
      113.5,
      119.2,
      106.7,
      76.1,
      49.2,
      24.9,
      15.9
    ],
    "polnoc": [
      11.1,
      17.5,
      31.0,
      58.6,
      83.3,
      95.2,
      95.7,
      70.4,
      35.2,
      20.2,
      11.8,
      8.7
    ]
  },
  "mazowieckie": {
    "poludnie": [
      33.9,
      48.1,
      86.7,
      119.5,
      127.6,
      132.9,
      131.9,
      126.2,
      101.5,
      69.7,
      32.3,
      25.0
    ],
    "poludnie_bok": [
      28.0,
      41.7,
      78.9,
      112.7,
      122.9,
      129.4,
      127.4,
      120.3,
      92.6,
      61.8,
      27.8,
      20.3
    ],
    "plaski": [
      22.9,
      37.3,
      74.7,
      112.0,
      128.3,
      137.5,
      134.5,
      121.5,
      89.4,
      55.2,
      23.4,
      16.5
    ],
    "wschod_zachod": [
      16.4,
      29.6,
      62.8,
      97.9,
      116.1,
      125.7,
      122.2,
      107.8,
      75.7,
      44.0,
      17.6,
      11.3
    ],
    "jedna_polac": [
      16.5,
      29.8,
      63.4,
      98.8,
      118.5,
      128.1,
      124.6,
      108.6,
      77.0,
      43.7,
      17.4,
      11.6
    ],
    "polnoc": [
      8.6,
      15.1,
      28.3,
      55.9,
      87.2,
      103.3,
      96.8,
      69.1,
      32.8,
      19.6,
      9.7,
      6.3
    ]
  },
  "opolskie": {
    "poludnie": [
      39.3,
      55.5,
      91.3,
      121.9,
      125.4,
      125.8,
      130.9,
      125.3,
      104.9,
      76.0,
      47.4,
      37.1
    ],
    "poludnie_bok": [
      32.8,
      48.6,
      84.2,
      115.8,
      121.8,
      124.2,
      128.1,
      119.3,
      96.7,
      68.0,
      40.3,
      30.8
    ],
    "plaski": [
      27.6,
      43.3,
      79.2,
      115.0,
      127.1,
      131.2,
      134.7,
      121.7,
      93.1,
      60.8,
      33.8,
      24.1
    ],
    "wschod_zachod": [
      20.1,
      34.2,
      66.9,
      100.7,
      115.4,
      120.3,
      123.1,
      108.0,
      78.8,
      48.5,
      24.8,
      16.5
    ],
    "jedna_polac": [
      20.4,
      34.1,
      66.4,
      100.7,
      116.5,
      121.0,
      123.9,
      109.7,
      79.3,
      47.6,
      24.5,
      16.3
    ],
    "polnoc": [
      10.6,
      16.9,
      30.4,
      59.1,
      88.8,
      100.8,
      99.0,
      71.4,
      34.9,
      21.0,
      12.0,
      8.1
    ]
  },
  "podkarpackie": {
    "poludnie": [
      41.9,
      50.4,
      86.2,
      116.8,
      122.5,
      125.8,
      132.3,
      130.9,
      106.1,
      79.8,
      45.7,
      34.0
    ],
    "poludnie_bok": [
      34.0,
      44.4,
      79.2,
      110.6,
      119.2,
      124.5,
      129.4,
      124.8,
      97.4,
      70.9,
      38.6,
      27.6
    ],
    "plaski": [
      29.3,
      40.6,
      76.2,
      110.8,
      124.4,
      131.1,
      136.0,
      126.9,
      94.4,
      63.6,
      33.1,
      23.0
    ],
    "wschod_zachod": [
      21.7,
      32.8,
      65.0,
      97.2,
      113.0,
      120.0,
      123.7,
      112.2,
      79.8,
      50.5,
      24.4,
      16.2
    ],
    "jedna_polac": [
      22.6,
      33.0,
      65.4,
      97.8,
      114.2,
      120.2,
      124.8,
      112.7,
      80.7,
      50.0,
      24.5,
      16.6
    ],
    "polnoc": [
      11.2,
      17.6,
      32.1,
      59.0,
      88.0,
      100.3,
      99.2,
      73.8,
      35.5,
      20.6,
      11.8,
      8.7
    ]
  },
  "podlaskie": {
    "poludnie": [
      29.1,
      43.1,
      81.0,
      121.4,
      132.4,
      134.6,
      133.7,
      125.0,
      101.0,
      66.5,
      26.9,
      21.2
    ],
    "poludnie_bok": [
      23.8,
      37.3,
      74.0,
      114.6,
      128.2,
      133.2,
      130.9,
      120.1,
      92.7,
      58.9,
      23.2,
      17.0
    ],
    "plaski": [
      19.8,
      33.6,
      70.2,
      113.0,
      132.2,
      138.7,
      135.7,
      119.8,
      88.4,
      52.2,
      19.6,
      13.7
    ],
    "wschod_zachod": [
      14.2,
      26.8,
      59.3,
      98.3,
      119.1,
      127.0,
      123.0,
      105.9,
      74.5,
      41.5,
      15.0,
      9.5
    ],
    "jedna_polac": [
      14.6,
      27.2,
      59.7,
      98.6,
      120.4,
      127.0,
      123.0,
      105.4,
      74.8,
      41.2,
      14.8,
      9.8
    ],
    "polnoc": [
      8.0,
      14.7,
      28.0,
      54.1,
      87.4,
      102.6,
      95.7,
      66.5,
      32.0,
      18.7,
      8.7,
      5.4
    ]
  },
  "pomorskie": {
    "poludnie": [
      26.2,
      43.9,
      81.0,
      122.9,
      131.5,
      128.2,
      126.0,
      118.1,
      97.5,
      65.5,
      26.6,
      19.2
    ],
    "poludnie_bok": [
      21.6,
      38.1,
      74.9,
      116.4,
      127.3,
      126.6,
      125.1,
      113.3,
      89.5,
      57.3,
      22.6,
      15.5
    ],
    "plaski": [
      17.5,
      33.4,
      69.4,
      113.9,
      131.4,
      132.5,
      128.5,
      113.7,
      85.3,
      51.0,
      19.0,
      12.3
    ],
    "wschod_zachod": [
      12.4,
      26.2,
      58.6,
      99.1,
      119.3,
      122.3,
      117.9,
      101.6,
      72.5,
      40.5,
      14.2,
      8.4
    ],
    "jedna_polac": [
      12.4,
      26.2,
      57.7,
      98.9,
      120.7,
      123.1,
      116.5,
      102.3,
      73.3,
      40.7,
      14.1,
      8.5
    ],
    "polnoc": [
      6.9,
      13.7,
      27.3,
      53.5,
      87.8,
      100.3,
      93.0,
      65.9,
      32.2,
      18.4,
      8.2,
      5.0
    ]
  },
  "slaskie": {
    "poludnie": [
      40.7,
      53.9,
      91.3,
      119.1,
      121.5,
      124.2,
      130.4,
      124.3,
      102.6,
      78.3,
      46.7,
      36.4
    ],
    "poludnie_bok": [
      33.6,
      47.4,
      83.5,
      112.0,
      117.3,
      121.6,
      127.7,
      117.8,
      94.5,
      69.7,
      40.0,
      29.7
    ],
    "plaski": [
      28.4,
      42.5,
      79.4,
      112.7,
      123.3,
      129.6,
      134.3,
      121.0,
      91.3,
      62.5,
      33.6,
      23.9
    ],
    "wschod_zachod": [
      20.9,
      33.9,
      67.1,
      98.8,
      112.2,
      118.9,
      122.7,
      108.0,
      77.7,
      49.7,
      24.8,
      16.6
    ],
    "jedna_polac": [
      21.3,
      33.7,
      67.4,
      100.2,
      114.5,
      120.6,
      123.6,
      110.4,
      78.6,
      49.1,
      24.4,
      16.8
    ],
    "polnoc": [
      10.8,
      17.2,
      30.6,
      59.2,
      87.2,
      100.3,
      98.9,
      72.0,
      35.1,
      20.8,
      12.0,
      8.4
    ]
  },
  "swietokrzyskie": {
    "poludnie": [
      38.0,
      52.2,
      90.2,
      119.9,
      125.8,
      130.3,
      131.4,
      127.8,
      104.8,
      77.6,
      41.6,
      33.8
    ],
    "poludnie_bok": [
      31.4,
      46.0,
      82.5,
      113.2,
      121.9,
      128.2,
      128.7,
      121.3,
      96.6,
      69.0,
      35.5,
      27.2
    ],
    "plaski": [
      26.6,
      41.4,
      78.7,
      113.2,
      127.3,
      135.6,
      134.9,
      123.8,
      92.9,
      61.8,
      30.1,
      22.3
    ],
    "wschod_zachod": [
      19.8,
      33.2,
      66.6,
      99.3,
      115.5,
      124.3,
      123.2,
      109.9,
      78.8,
      49.2,
      22.5,
      15.4
    ],
    "jedna_polac": [
      20.2,
      33.1,
      67.1,
      100.3,
      117.1,
      125.4,
      123.9,
      111.6,
      79.2,
      48.8,
      22.4,
      15.8
    ],
    "polnoc": [
      10.8,
      17.4,
      30.9,
      58.9,
      88.7,
      103.7,
      98.7,
      72.5,
      34.8,
      20.8,
      11.4,
      8.0
    ]
  },
  "warminsko-mazurskie": {
    "poludnie": [
      28.0,
      46.1,
      82.7,
      121.1,
      131.9,
      129.6,
      127.4,
      120.2,
      97.8,
      63.9,
      25.1,
      20.2
    ],
    "poludnie_bok": [
      23.2,
      39.8,
      75.1,
      114.5,
      127.1,
      127.6,
      124.5,
      115.1,
      89.5,
      56.4,
      21.4,
      16.6
    ],
    "plaski": [
      18.8,
      35.0,
      71.0,
      112.6,
      131.5,
      133.6,
      129.7,
      115.4,
      85.7,
      50.1,
      18.2,
      13.1
    ],
    "wschod_zachod": [
      13.3,
      27.4,
      59.9,
      98.2,
      118.7,
      122.6,
      118.3,
      102.7,
      72.5,
      39.8,
      13.8,
      8.8
    ],
    "jedna_polac": [
      13.4,
      27.5,
      60.6,
      98.3,
      120.5,
      123.4,
      119.1,
      103.0,
      73.3,
      39.7,
      13.7,
      8.8
    ],
    "polnoc": [
      7.4,
      13.8,
      27.9,
      54.0,
      86.9,
      99.6,
      93.1,
      65.6,
      32.3,
      18.2,
      8.1,
      5.1
    ]
  },
  "wielkopolskie": {
    "poludnie": [
      32.3,
      48.2,
      87.5,
      130.7,
      134.2,
      134.0,
      133.6,
      128.7,
      106.8,
      74.5,
      38.4,
      27.5
    ],
    "poludnie_bok": [
      26.9,
      41.8,
      80.2,
      123.7,
      130.0,
      132.6,
      130.3,
      123.3,
      97.9,
      65.4,
      32.4,
      22.6
    ],
    "plaski": [
      22.2,
      37.3,
      75.3,
      121.7,
      134.7,
      138.8,
      136.5,
      123.8,
      93.6,
      58.5,
      27.1,
      17.9
    ],
    "wschod_zachod": [
      16.1,
      29.3,
      63.2,
      105.8,
      121.7,
      127.3,
      124.5,
      109.5,
      78.8,
      46.1,
      19.8,
      12.2
    ],
    "jedna_polac": [
      16.2,
      29.4,
      63.0,
      105.8,
      122.8,
      127.6,
      125.6,
      110.0,
      79.5,
      46.1,
      19.7,
      12.2
    ],
    "polnoc": [
      8.9,
      15.0,
      28.3,
      57.8,
      90.3,
      104.2,
      98.3,
      69.9,
      33.2,
      19.9,
      10.1,
      6.6
    ]
  },
  "zachodniopomorskie": {
    "poludnie": [
      26.1,
      46.7,
      83.9,
      124.8,
      129.6,
      131.2,
      129.3,
      120.6,
      99.4,
      65.5,
      31.4,
      21.2
    ],
    "poludnie_bok": [
      21.4,
      40.4,
      76.5,
      117.5,
      125.3,
      130.3,
      127.2,
      115.3,
      91.0,
      57.5,
      26.7,
      17.1
    ],
    "plaski": [
      17.8,
      35.5,
      71.6,
      116.0,
      130.1,
      135.5,
      131.7,
      116.2,
      87.1,
      51.6,
      22.2,
      13.7
    ],
    "wschod_zachod": [
      13.0,
      27.6,
      60.0,
      101.1,
      118.5,
      124.8,
      120.7,
      103.6,
      74.0,
      41.0,
      16.4,
      9.5
    ],
    "jedna_polac": [
      13.3,
      27.6,
      59.9,
      102.2,
      120.7,
      124.3,
      120.7,
      104.8,
      75.0,
      41.2,
      16.2,
      9.6
    ],
    "polnoc": [
      7.5,
      13.7,
      27.1,
      55.0,
      88.1,
      101.7,
      95.1,
      67.0,
      32.6,
      18.9,
      9.0,
      5.5
    ]
  }
}
